import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import config from '../config/config'
import ManageItemAddPhotos from '../components/ManageItemAddPhotos'
import ManageItemPhotosList from '../components/ManageItemPhotosList'
import ManagePoiNavBar from '../components/PointOfInterest/ManagePoiNavBar'
import PoiTechnicalSheet from '../components/PointOfInterest/PoiTechnicalSheet'
import { setFlashMessage } from '../contexts/WebsiteContext'

const ManagePoiPhotos = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [poi, setPoi] = useState(null)
  const [refreshList, setRefreshList] = useState()

  useEffect(() => {
    const fetchPoi = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}poi/${id}`)
        setPoi(response.data)
      } catch (error) {
        // console.error('An error occurred:', error);
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    }

    fetchPoi()
  }, [id, t])

  const handleAddPhotos = () => {
    setRefreshList(!refreshList)
  }

  const handleUpdatePhotoRanking = () => {
    setRefreshList(!refreshList)
  }

  return (
    <div>
      <NavigationBar />
      <h1>{t('MANAGE_PHOTOS')}</h1>
      <ManagePoiNavBar />
      {poi && <PoiTechnicalSheet poi={poi} />}
      {poi && (
        <ManageItemAddPhotos item={poi}
                             itemType={'POI'}
                             handleAddPhotos={handleAddPhotos} />
      )}
      {poi && (
        <ManageItemPhotosList
          item={poi}
          itemType={'POI'}
          refreshList={refreshList}
          handleUpdatePhotoRanking={handleUpdatePhotoRanking}
        />
      )}
      <Footer />
    </div>
  )
}

export default ManagePoiPhotos
